import path from 'node:path'
import { scopeDir } from './scope-dir.js'

export function filesDir(cwd: string, scope: string): string {
  return path.join(scopeDir(cwd, scope), 'files')
}
